import styled from "styled-components";

import colors from "../../../global/colors";
import fontSize from "../../../global/fontSize";

export const AboutUsContainer = styled.div`
  position: relative;
  width: 100vw;
  background-image: linear-gradient(#fff, ${colors.backgroundLinearGrey});
  overflow-x: hidden;
`;

export const FirstSlideTextContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  height: 40%;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  text-align: center;

  @media (max-width: 750px) {
    height: 75%;
    justify-content: start;
    gap: 10px;
  }
`;

export const SecondSlideTextContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  align-items: center;
  flex-direction: column;
  height: 40%;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  text-align: center;
`;

export const ThirdSlideTextContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  height: 60%;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  text-align: center;

  @media (max-width: 750px) {
    height: 60%;
  }
`;

export const Header = styled.h2`
  font-weight: 800;
  font-size: ${fontSize.secondMainHeader};
  text-shadow: 3px 3px 10px rgba(0, 0, 0, 0.25);

  @media (max-width: 1250px) {
    font-size: ${fontSize.smallHeader};
  }

  @media (max-width: 750px) {
    font-size: 40px;
  }

  @media (max-width: 500px) {
    font-size: 32px;
  }
`;

export const SlideText = styled.p`
  padding: 0 200px;

  @media (max-width: 1000px) {
    padding: 0 50px;
  }

  @media (max-width: 500px) {
    font-size: 14px;
  }
`;

export const InformationContainer = styled.div`
  width: 100%;
  margin-top: 6rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const InformationColumn = styled.div`
  width: 500px;
  height: 250px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1500px) {
    width: 400px;
  }

  @media (max-width: 550px) {
    width: 300px;
  }
`;

export const Information1stRow = styled.div`
  height: 100px;
  margin-top: 40px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;

  @media (max-width: 550px) {
    height: unset;
    margin-bottom: 20px;
  }
`;

export const InformationImg = styled.img`
  width: 45px;
  height: 45px;
  margin-right: 25px;

  @media (max-width: 550px) {
    width: 35px;
    height: 35px;
  }
`;

export const Information2ndRow = styled.div`
  padding-left: 75px;
  max-width: 70%;

  @media (max-width: 550px) {
    padding-left: 65px;
  }
`;

export const InformationHeader = styled.h4`
  color: ${colors.black};
  font-weight: 800;
  font-size: ${fontSize.text24};

  @media (max-width: 550px) {
    font-size: ${fontSize.text};
  }
`;

export const InformationParagraph = styled.p`
  font-weight: 400;

  @media (max-width: 550px) {
    font-size: 14px;
  }
`;

export const SliderContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const CustomDotWrapper = styled.button`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin: 0 4px;
  border: none;
  background-color: ${(props) => (props.active ? "#BED701" : "#ccc")};
  cursor: pointer;
  margin-bottom: 10px;
`;

export const ClarkLogo = styled.img`
  position: absolute;
  right: 5%;
  bottom: 5%;
  width: 150px;
  opacity: 100%;

  @media (max-width: 750px) {
    width: 100px;
  }
`;
